/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_User,
  ListCommandResult_User
} from "@graphql/helpers/types.graphql";
import {
  CommandResult,
  ListCommandResult
} from "@graphql/groups/fragment.graphql";
import utils, {
  TNonEmptyArray,
  TUserType,
  TPermissionUserType,
  TJoin
} from "@graphql/helpers/utils.graphql";

type TUserByIdFunctions = {
  getByID: CommandResult_User;
};
export type TUserByIdQueries = {
  user: TUserByIdFunctions;
};

export const userById = (fields: TNonEmptyArray<TUserType>) => gql`
  query userById($id: Guid!) {
    user {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_User")}
`;

type TUserTypeWithPermissions =
TUserType
| TJoin<"permissions", TPermissionUserType>;

type TUserAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_User;
};
export type TUserAllWithPaginationQueries = {
  user: TUserAllWithPaginationFunctions;
};
export const userAllWithPagination = (fields: TNonEmptyArray<TUserTypeWithPermissions>) => gql`
  query userAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    user {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_User")}
`;
